module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "sign",
    attrs: {
      "id": "sign"
    }
  }, [_c('div', {
    staticClass: "pTitle"
  }, [_vm._v("\n        忘记密码\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sign-body"
  }, [_c('div', {
    staticClass: "s-form",
    attrs: {
      "id": "signUp"
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step1),
      expression: "step1"
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    ref: "phone",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnPhone),
      expression: "warnPhone"
    }],
    ref: "warn",
    staticClass: "warning"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.vertify),
      expression: "user.vertify"
    }],
    ref: "vertify",
    staticStyle: {
      "flex": "1",
      "margin-right": "5px"
    },
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.vertify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "vertify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasCounted),
      expression: "!hasCounted"
    }],
    ref: "getVCode",
    staticClass: "btn-code",
    on: {
      "click": _vm.getVertifyCode
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasCounted),
      expression: "hasCounted"
    }],
    staticClass: "btn-count"
  }, [_vm._v(_vm._s(_vm.count) + "秒后重新发送")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vertifyTip),
      expression: "vertifyTip"
    }],
    ref: "vertifyTip",
    staticClass: "warning"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('button', {
    staticClass: "btn btn-normal"
  }, [_vm._v("已有账号，登录")])])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.modifyPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step2),
      expression: "step2"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "name": "name",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "passwordTip",
    staticClass: "warning"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("再次输入密码")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }],
    attrs: {
      "name": "name",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "confirmPassword",
    staticClass: "warning"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "signUp"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "6px"
    },
    attrs: {
      "type": "submit",
      "value": "确认"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }]
  }, [_vm._v("修改成功!")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3a4ee12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgetPassword/forgetPassword.vue
// module id = 528
// module chunks = 1